var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2325 4.90215V9.3666C10.2325 10.2814 10.2325 10.7387 10.0723 11.0881C9.93133 11.3954 9.70645 11.6453 9.42985 11.8019C9.1154 11.9799 8.70376 11.9799 7.88048 11.9799H4.25448C3.4312 11.9799 3.01956 11.9799 2.70511 11.8019C2.42852 11.6453 2.20363 11.3954 2.0627 11.0881C1.90248 10.7387 1.90248 10.2814 1.90248 9.3666V4.90215M1.95148 2.17993H10.1835C10.4579 2.17993 10.5951 2.17993 10.6999 2.23927C10.7921 2.29147 10.8671 2.37476 10.9141 2.4772C10.9675 2.59367 10.9675 2.74613 10.9675 3.05104V4.03104C10.9675 4.33596 10.9675 4.48842 10.9141 4.60488C10.8671 4.70733 10.7921 4.79062 10.6999 4.84281C10.5951 4.90215 10.4579 4.90215 10.1835 4.90215H1.95148C1.67705 4.90215 1.53984 4.90215 1.43503 4.84281C1.34283 4.79062 1.26787 4.70733 1.22089 4.60488C1.16748 4.48842 1.16748 4.33596 1.16748 4.03104V3.05104C1.16748 2.74613 1.16748 2.59367 1.22089 2.4772C1.26787 2.37476 1.34283 2.29147 1.43503 2.23927C1.53984 2.17993 1.67705 2.17993 1.95148 2.17993ZM4.89148 6.80771H7.24348C7.51791 6.80771 7.65512 6.80771 7.75994 6.86705C7.85214 6.91925 7.9271 7.00254 7.97407 7.10498C8.02748 7.22144 8.02748 7.3739 8.02748 7.67882V8.11438C8.02748 8.41929 8.02748 8.57175 7.97407 8.68822C7.9271 8.79066 7.85214 8.87395 7.75994 8.92615C7.65512 8.98549 7.51791 8.98549 7.24348 8.98549H4.89148C4.61705 8.98549 4.47984 8.98549 4.37503 8.92615C4.28283 8.87395 4.20787 8.79066 4.16089 8.68822C4.10748 8.57175 4.10748 8.41929 4.10748 8.11438V7.67882C4.10748 7.3739 4.10748 7.22144 4.16089 7.10498C4.20787 7.00254 4.28283 6.91925 4.37503 6.86705C4.47984 6.80771 4.61705 6.80771 4.89148 6.80771Z",
    stroke: "#254E9C",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.0502,
    y: 0.779932,
    width: 4.9,
    height: 4.9,
    rx: 2.45,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.0502,
    y: 0.779932,
    width: 4.9,
    height: 4.9,
    rx: 2.45,
    stroke: "#254E9C",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7904 2.42993L9.87044 4.34993L9.00049 3.47999",
    stroke: "#254E9C",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.8be36f038ec3d57d0c00e7876070f3e2.svg";
export { ForwardRef as ReactComponent };